import { Map as ImmutableMap, OrderedSet as ImmutableOrderedSet } from 'immutable';

import {
  REACTIONS_FETCH_SUCCESS,
  REACTIONS_EXPAND_SUCCESS,
  REACTIONS_FETCH_REQUEST,
  REACTIONS_EXPAND_REQUEST,
  REACTIONS_FETCH_FAIL,
  REACTIONS_EXPAND_FAIL,
} from '../actions/interactions';

const initialState = ImmutableMap({
  reactions: ImmutableMap(),
});

const normalizeReaction = reaction => ({
  ...reaction,
  account: reaction.account.id,
});

const normalizeList = (state, path, reactions, next) => {
  const normalizedReactions = reactions.map(normalizeReaction);

  return state.setIn(path, ImmutableMap({
    next,
    items: ImmutableOrderedSet(normalizedReactions),
    isLoading: false,
  }));
};

const appendToList = (state, path, reactions, next) => {
  const normalizedReactions = reactions.map(normalizeReaction);

  return state.updateIn(path, ImmutableMap(), map => map
    .set('next', next)
    .set('isLoading', false)
    .update('items', ImmutableOrderedSet(), list => list.concat(normalizedReactions)));
};

export default function statusReactions(state = initialState, action) {
  switch(action.type) {
  case REACTIONS_FETCH_SUCCESS:
    return normalizeList(state, ['reactions', action.id], action.reactions, action.next);
  case REACTIONS_EXPAND_SUCCESS:
    return appendToList(state, ['reactions', action.id], action.reactions, action.next);
  case REACTIONS_FETCH_REQUEST:
  case REACTIONS_EXPAND_REQUEST:
    return state.setIn(['reactions', action.id, 'isLoading'], true);
  case REACTIONS_FETCH_FAIL:
  case REACTIONS_EXPAND_FAIL:
    return state.setIn(['reactions', action.id, 'isLoading'], false);
  default:
    return state;
  }
}
